import 'slick-carousel/slick/slick';

function initSpeakersSlider(id) {
  $('#' + id).slick({
    infinite: false,
    dots: false,
    speed: 700,
    autoplay: false,
    slidesToShow: 6,
    slidesToScroll: 6,
      responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        }
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
    ],
    nextArrow:
      '<button type="button" class="slick-next" aria-label="Next slide"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 23.67 40.58" style="enable-background:new 0 0 23.67 40.58;" xml:space="preserve"><path fill="#003a56" opacity="0.85" d="M22.63,22.55L5.65,39.54c-1.26,1.26-3.3,1.26-4.55,0c-1.26-1.26-1.26-3.29,0-4.55l14.71-14.72L1.09,5.56 c-1.26-1.26-1.26-3.3,0-4.55c0.63-0.63,1.45-0.94,2.27-0.94s1.65,0.31,2.28,0.94L22.63,18c0.63,0.63,0.94,1.45,0.94,2.28 C23.57,21.1,23.26,21.92,22.63,22.55"/></svg></button>',
    prevArrow:
      '<button type="button" class="slick-prev" aria-label="Previous slide"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 23.67 40.58" style="enable-background:new 0 0 23.67 40.58;" xml:space="preserve"><path fill="#003a56" opacity="0.85" d="M1.08,18.01L18.06,1.02c1.26-1.26,3.3-1.26,4.55,0c1.26,1.26,1.26,3.29,0,4.55L7.9,20.29L22.62,35 c1.26,1.26,1.26,3.3,0,4.55c-0.63,0.63-1.45,0.94-2.27,0.94c-0.82,0-1.65-0.31-2.28-0.94L1.08,22.56c-0.63-0.63-0.94-1.45-0.94-2.28 C0.14,19.46,0.45,18.64,1.08,18.01"/></svg></button>',
  });

}
window.initSpeakersSlider = initSpeakersSlider;
